













































import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderItem } from '@/models/order/OrderItem';
import { padleft } from '@/services/StringService';
import ColorDisplay from '@/components/App/Catalog/ColorDisplay.vue';

@Component({
    components: {
        'app-color-display': ColorDisplay
    }
})
export default class OrderPanel extends Vue {
    @Prop({ required: true })
    public order!: OrderItem;
}
